import "../App.css";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { fetchOneMovie } from "../stores/actions/movieAction";
import ModalCard from "../components/ModalCard";

function DetailPage() {
  const { movie } = useSelector((state) => state.movies);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [modalCastShow, setModalCastShow] = useState("hidden");

  const params = useParams();
  const onClickCast = () => {
    setModalCastShow("top-30 z-50");
  };
  const onCloseCast = () => {
    setModalCastShow("hidden");
  };
  useEffect(() => {
    dispatch(fetchOneMovie(params.id))
      .then(() => {
        setLoading(false);
      })
      .catch((err) => {
        setError(true);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err,
        });
      });
  }, []);

  function showLoading() {
    Swal.fire({
      title: "Loading",
      timer: 1200,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }
  return (
    <>
      {loading && showLoading()}
      {!loading && (
        <div className="mt-20 my-8 grid min-h-screen place-items-center">
          <div className="w-11/12 p-12 rounded-lg bg-biru 153e5c sm:w-8/12 md:w-1/2 lg:w-9/12">
            <div className="w-full p-6 rounded-md bg-white">
              <iframe
                className="rounded-lg w-9/12 aspect-video mx-auto"
                src={movie.trailerUrl}
              ></iframe>
              <div className="flex flex-row my-4 h-48">
                <div className="bg-red-500 rounded-md w-1/4 flex items-center justify-center">
                  <img
                    src={movie.imgUrl}
                    className="h-full w-full rounded-md"
                  />
                </div>
                <div className="bg-biru-coral h-48 rounded-md ml-4 w-3/4 flex flex-col items-center justify-center">
                  <h1 className="text-2xl font-bold text-biru">
                    {movie.title}
                  </h1>
                  <h1 className="font-bold mt-0 text-lg text-biru">
                    {movie.Genre.name}
                  </h1>
                  <div className="my-1 flex items-center justify-center">
                    <button
                      className="block text-white bg-biru hover:bg-biru-gelap focus:ring-4 focus:outline-none focus:ring-biru font-medium rounded-lg text-sm px-4 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                      type="button"
                      data-modal-toggle="defaultModal"
                      onClick={onClickCast}
                    >
                      View Casts
                    </button>
                  </div>
                  <div className={modalCastShow}>
                    <div
                      show="false"
                      onClose={onCloseCast}
                      id="defaultModal"
                      tabIndex="-1"
                      className="bg-black/60 overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 w-full md:inset-0 h-modal md:h-full justify-center align-middle items-center flex"
                      aria-modal="true"
                      role="dialog"
                    >
                      <div className="max-h-96 relative p-4 py-8 w-full max-w-2xl h-full md:h-auto">
                        <div className="relative bg-kuning rounded-lg drop-shadow-xl">
                          <div className="flex justify-between items-start p-4 rounded-t border-b border-biru">
                            <h3 className="text-xl font-semibold text-biru">
                              {movie.title}
                            </h3>
                            <button
                              type="button"
                              className="text-biru bg-transparent hover:bg-biru hover:text-kuning rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                              data-modal-toggle="defaultModal"
                              show={modalCastShow}
                              onClick={onCloseCast}
                            >
                              <svg
                                aria-hidden="true"
                                className="w-5 h-5"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                ></path>
                              </svg>
                            </button>
                          </div>
                          <p className="text-center text-2xl font-bold text-biru">
                            Cast List
                          </p>
                          {!movie.Casts.length && (
                            <p className="mt-4 mb-4 text-xl font-semibold text-biru">
                              Sorry we can't find any cast for this movie
                            </p>
                          )}
                          <div className="grid place-items-center justify-center mb-3 grid-cols-5">
                            {movie.Casts.map((el, idx) => (
                              <ModalCard cast={el} key={el.id + "cast"} />
                            ))}
                          </div>
                          <div className="mt-5 flex items-center p-4 space-x-2 rounded-b border-t border-biru">
                            <p className="font-semibold text-base leading-relaxed text-biru">
                              Genre: {movie.Genre.name}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h4
                    className="mt-1
                 text-md font-semibold text-biru"
                  >
                    Rating
                  </h4>
                  <h1 className="text-2xl font-bold text-kuning">
                    {movie.rating}/10
                  </h1>
                </div>
              </div>
              <div className="flex flex-col mt-4">
                <div className="bg-kuning w-full h-7 flex items-center justify-start pl-10">
                  <h1 className="text-3xl font-semibold text-biru bg-white h-full w-36 my-auto text-center flex items-center justify-center">
                    Synopsis
                  </h1>
                </div>
                <div className="mt-4">
                  <p className="text-left text-biru">{movie.synopsis}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DetailPage;
